import request from "@/utils/request.js";
import { handlerGetUrlParams } from "@/utils/dealUrlParams.js";

export function getHomeData(params, data) {
  const url = handlerGetUrlParams("bus/article/home/list", params);
  return request({
    url,
    method: "POST",
    data,
  });
}

export function articleDetail(data) {
  return request({
    url: "/bus/article/home/" + data.id,
    method: "GET",
  });
}
export function downFile(id) {
  return request({
    url: "/common/partial_download/" + id,
    method: "GET",
    responseType: 'blob'
  });
}

